import React, { useMemo, useState, useRef, useEffect } from "react";
import { Button, Checkbox, Icon, Input, Select, Spin } from "antd";
import { debounce, filter } from "lodash";
import CustomModal from "../../../Common-Modal/CustomModal";
import CustomAgGridTable from "../../../Common-Table/CustomAgGridTable";
import CheckBoxRenderer from "./CheckBoxRenderer";
import { Translate } from "react-translated";
import axios from "axios";

import "./CheckBoxRenderer.css";
import { CarrierList } from "../../../utils/Constants";
import CustomHeader from "../../../CommonHeader/CustomHeader";
import DownArrowIcon from "../../../scenes/LandingPage/images/new/down-arrow.png";


const { Search } = Input;
const { Option } = Select;
const AgencyModal = (props) => {
  const gridApiRef = useRef(null); // Reference to the grid API
  const {
    isVisible,
    closeModal,
    title,
    agencies,
    user_agencies,
    parentInstance,
    has_user = true,
  } = props;

  // console.log("user_agencies", user_agencies);


  const [searchTerm, setSearchTerm] = useState("");
  const [carrierFilter, setCarrierFilter] = useState(undefined);
  const [stateFilter, setStateFilter] = useState(undefined);
  const [stateList, setStateList] = useState([]);

  const [sortOrders, setSortOrders] = useState({});
  const [carrierDropdownOpen, setCarrierDropdownOpen] = useState(false);
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false);
  const carrierWrapperRef = useRef(null);
  const stateWrapperRef = useRef(null);

  const getCountryDropDown = async () => {
    try {
      const {
        data: { states },
      } = await axios.get("/api/google_maps/list_states_in_usa");
      setStateList(states);
    } catch (error) {
      console.log("Something went wrong");
    }
  };

  useEffect(() => {
    getCountryDropDown();
  }, []);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (carrierWrapperRef.current && !carrierWrapperRef.current.contains(event.target)) {
        setCarrierDropdownOpen(false);
      }
      if (stateWrapperRef.current && !stateWrapperRef.current.contains(event.target)) {
        setStateDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleButtonClick = (data, checked, setIsChecked) => {
    const updatedRow = {
      ...data,
      isChecked: checked,
    };

    // console.log(updatedRow, "updatedRow");

    gridApiRef.current.api.applyTransaction({
      update: [updatedRow], // The updated row is in an array
    });

    parentInstance.updateAgencyAssoc(data.id, checked);
    // Call the updateData function with the updated row data
  };

  const updateData = (id, checked) => {
    const updatedDataArr = agencies.map((row) =>
      row.id === id ? { ...row, isChecked: checked } : row
    );

    // Update the state with the modified rowData
    // setAgenciesArr(updatedDataArr);
    parentInstance.setState((prevState) => ({
      ...prevState,
      agencies: updatedDataArr,
    }));
    //  update state here of data
  };


  const CustomTooltip = (props) => {
    return (
      <div style={{
        background: "rgba(0, 0, 0, 0.8)",
        color: "white",
        padding: "8px 12px",
        borderRadius: "4px",
        fontSize: "12px",
        maxWidth: "200px",
        textAlign: "center"
      }}>
        {props.value}
      </div>
    );
  };

  const columnSortAgencyOwner = (field, newOrder) => {
    let updatedAgencies = [...props.agencies];

    if (field === "agency_owner" && newOrder === "asc") {
      updatedAgencies.sort((a, b) => a.agency_owner_first_name.localeCompare(b.agency_owner_first_name));
    } else {
      updatedAgencies.sort((a, b) => b.agency_owner_first_name.localeCompare(a.agency_owner_first_name));
    }

    parentInstance.setState(prevState => ({
      ...prevState,
      sortOrders: newOrder,
      agencies: [...updatedAgencies]
    }))

  }

  const columnSortAgency = (field, newOrder) => {
    let updatedAgencies = [...props.agencies];

    if (field === "name" && newOrder === "asc") {
      updatedAgencies.sort((a, b) => a.name.localeCompare(b.name));
    } else {
      updatedAgencies.sort((a, b) => b.name.localeCompare(a.name));
    }

    parentInstance.setState(prevState => ({
      ...prevState,
      sortOrders: newOrder,
      agencies: [...updatedAgencies]
    }))

  }

  const columnSortState = (field, newOrder) => {
    let updatedAgencies = [...props.agencies];

    if (field === "state" && newOrder === "asc") {
      updatedAgencies.sort((a, b) => {
        // Handle null values by treating them as lower or higher than any string
        const nameA = a.agency_owner_state || ""; // Treat null as empty string
        const nameB = b.agency_owner_state || ""; // Treat null as empty string
        return nameA.localeCompare(nameB);
      });
    } else {
      updatedAgencies.sort((a, b) => {
        // Handle null values by treating them as lower or higher than any string
        const nameA = a.agency_owner_state || ""; // Treat null as empty string
        const nameB = b.agency_owner_state || ""; // Treat null as empty string
        return nameB.localeCompare(nameA);
      });
    }

    parentInstance.setState(prevState => ({
      ...prevState,
      sortOrders: newOrder,
      agencies: [...updatedAgencies]
    }))

  }
  

  const columnSortCarrier = (field, newOrder) => {
    let updatedAgencies = [...props.agencies];

    const safeCompare = (a, b, key, order = "asc") => {
      const valA = a[key] || "";
      const valB = b[key] || "";
      return order === "asc"
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    };

  
    if (field === "carrier") {
      updatedAgencies.sort((a, b) =>
        safeCompare(a, b, "agency_owner_carrier", newOrder)
      );
    } else if (field === "name") {
      updatedAgencies.sort((a, b) =>
        safeCompare(a, b, "name", newOrder)
      );
    }

    parentInstance.setState(prevState => ({
      ...prevState,
      sortOrders: newOrder,
      agencies: updatedAgencies
    }));
  };




  const handleSort = (field) => {
    // console.log("field: " , field)
    let newOrder;
    setSortOrders((prev) => {
      const currentOrder = prev[field] || "asc";
      newOrder = currentOrder === "asc" ? "desc" : "asc";
      return { ...prev, [field]: newOrder };
    });

    if (field === "agency_owner") {
      columnSortAgencyOwner(field, newOrder);
    } else if (field === "name") {
      columnSortAgency(field, newOrder);
    } else if (field === "state") {
      columnSortState(field, newOrder);
    } else if (field === "carrier") {
      columnSortCarrier(field, newOrder);
    }

    // setLocalOrder(newOrder);
    // setLocalField(field);
    // loadUsers()
  };


  const coleDef = [
    // {
    //   headerCheckboxSelection: false, // Checkbox in the header to select/deselect all rows
    //   checkboxSelection: true, // Checkbox for each row
    //   width: 50, // Width of the checkbox column
    // },
    {
      headerName: "",
      cellRendererFramework: CheckBoxRenderer,
      width: 70,
      filter: false,
      sortable: false,
      // cellRendererParams: {
      //   onButtonClick: (buttonType, data) =>
      //     handleButtonClick(buttonType, data),
      // },
      cellRendererParams: {
        user_agencies,
        onButtonClick: (data, checked, setIsChecked, rowNode) => {
          handleButtonClick(data, checked, setIsChecked, rowNode) // NOSONAR
        }, // Pass as callback
        updateData,
      },
    },
    {
      // headerName: "Agency Owner",
      // field: "agency_owner",
      // sortable: true,
      // filter: true,
      headerClass: 'custom-ag-header',
      headerName: "Agency Owner",
      valueGetter: (params) => `${params.data.agency_owner || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["agency_owner"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Agency Owner"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "agency_owner",
        sortOrder: sortOrders["agency_owner"],
        handleSort
      }),
      colId: 'agency_owner',
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      // headerName: "Agency ",
      // field: "name",
      // sortable: true,
      // filter: true,
      // width:300,
      width: 300,
      headerClass: 'custom-ag-header',
      headerName: "Agency",
      valueGetter: (params) => `${params.data.name || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["name"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Agency"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "name",
        sortOrder: sortOrders["name"],
        handleSort
      }),
      colId: 'name',
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      // headerName: "State",
      // field: "state",
      // sortable: true,
      // filter: true,
      // width:200,
      width: 200,
      headerClass: 'custom-ag-header',
      headerName: "State",
      valueGetter: (params) => `${params.data.state || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["state"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["State"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "state",
        sortOrder: sortOrders["state"],
        handleSort
      }),
      colId: 'state',
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      // headerName: "Carrier",
      // field: "carrier",
      // sortable: true,
      // filter: true,
      headerClass: 'custom-ag-header',
      headerName: "Carrier",
      valueGetter: (params) => `${params.data.carrier || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["carrier"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Carrier"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "carrier",
        sortOrder: sortOrders["carrier"],
        handleSort
      }),
      colId: 'carrier',
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
  ];
  const modifiedData = agencies.map((agency, i) => {
    return {
      agency_owner: `${agency.agency_owner_first_name} ${agency.agency_owner_last_name}`,
      name: agency.name,
      state: agency.agency_owner_state,
      carrier: agency.agency_owner_carrier,
      ...agency,
    };
  })
    .sort((a, b) => b.isChecked - a.isChecked) // sort based on checked and checked comes first 

  // const debouncedSearch = useMemo(
  //   () =>
  //     debounce((value) => {
  //       setSearchTerm(value);
  //     }, 300),
  //   []
  // );

  const handleSearchChange = (e) => {
    // debouncedSearch(e.target.value);
    setSearchTerm(e.target.value)
  };

  const handleCarrierChange = (value) => {
    setCarrierFilter(value);
  };

  const handleStateChange = (value) => {
    setStateFilter(value);
  };

  //   const applyFilters = (agency) => {
  //     let isMatch = true;

  //     // Search filter
  //     if (
  //       searchTerm && 
  //       !(agency.name && agency.name.toLowerCase().includes(searchTerm.toLowerCase())) &&
  //       !(agency.agency_owner && agency.agency_owner.toLowerCase().includes(searchTerm.toLowerCase()))
  //     ) {
  //       isMatch = false;
  //     }

  //     // Carrier filter
  //     if (
  //       carrierFilter &&
  //       !(agency.carrier && agency.carrier.toLowerCase() === carrierFilter.toLowerCase())
  //     ) {
  //       isMatch = false;
  //     }

  //     // State filter
  //     if (
  //       stateFilter &&
  //       !(agency.state && agency.state.toLowerCase() === stateFilter.toLowerCase())
  //     ) {
  //       isMatch = false;
  //     }

  //     return isMatch;
  // };

  const applyFilters = (agency) => {
    if (!agency) return false;

    // Convert search term to lowercase once
    const lowerSearchTerm = searchTerm && searchTerm.toLowerCase();

    // Search filter
    if (
      lowerSearchTerm &&
      !(
        (agency.name && agency.name.toLowerCase().includes(lowerSearchTerm)) ||
        (agency.agency_owner && agency.agency_owner.toLowerCase().includes(lowerSearchTerm))
      )
    ) {
      return false;
    }

    // Carrier filter (now supports multiple values)
    if (
      Array.isArray(carrierFilter) &&
      carrierFilter.length > 0 &&
      !carrierFilter.some(
        (carrier) => agency.carrier && carrier.toLowerCase() === agency.carrier.toLowerCase()
      )
    ) {
      return false;
    }

    // State filter (now supports multiple values)
    if (
      Array.isArray(stateFilter) &&
      stateFilter.length > 0 &&
      !stateFilter.some(
        (state) => agency.state && state.toLowerCase() === agency.state.toLowerCase()
      )
    ) {
      return false;
    }

    return true;
  };
  const handleSelectionChanged = () => {
    if (gridApiRef.current) {
      // TODO: Handle selection changes here
      const selectedRowsData = gridApiRef.current.api.getSelectedNodes(); // Get selected rows from the grid

      // console.log("selectedRowsData",selectedRowsData)
      // Extract just the IDs of selected rows
      const selectedIds = selectedRowsData.map((row) => row.data.id); // New Set with just row IDs

      // console.log("selectedIds==>",selectedIds[0])
    }
  };

  // Apply filters to the data
  const filteredData = useMemo(() => {
    return modifiedData.filter(applyFilters);
  }, [modifiedData, searchTerm, carrierFilter, stateFilter]);

  const gridOptions = {
    getRowStyle: (params) => {
      if (params.node.isSelected()) {
        return { backgroundColor: "transparent" }; // Remove selected row background
      }
      return null;
    },
    onGridReady: (params) => {
      gridApiRef.current = params.api; // Assign the grid API to the ref when the grid is ready
    },
  };

  const checkCheckboxesBasedOnCondition = () => {
    if (gridApiRef.current) {
      gridApiRef.current.forEachNode((node) => {
        if (user_agencies.indexOf(node.data.id) >= 0) {
          node.setSelected(true); // Check the checkbox
        }
      });
    }
  };

  const onGridReady = (params) => {
    gridApiRef.current = params; // Store grid API reference
    setTimeout(() => {
      // Iterate through all rows and select those whose ids are in userAgencies

      params.api.forEachNode((node) => {

        // console.log("test condition", user_agencies.indexOf(node.data.id) >= 0); // For debugging purposes

        // Check if the node's agency.id is in user_agencies
        if (user_agencies.indexOf(node.data.id) >= 0) {
          node.setSelected(true); // Select row where agency.id is in user_agencies
        }
      });
    }, 100);
  };


  const refreshTableData = () => {
    setSearchTerm("")
    setSearchTerm(undefined);
    setCarrierFilter(undefined);
    setStateFilter(undefined);


  }

  return (
    <CustomModal
      isVisible={isVisible}
      setIsVisible={closeModal}
      title={title}
      width={"85%"}
      footer={
        <div>
          <Button
            className="borderRadius-28"
            onClick={() => {
              parentInstance.handleCloseModal();
              has_user ? parentInstance.loadUserAgencies(parentInstance.state.user.id) : null; // NOSONAR
            }}
          >
            <Translate text={`Cancel`} />
          </Button>
        </div>
      }
      cb={() => {
        parentInstance.handleCloseModal();
        has_user ? parentInstance.loadUserAgencies(parentInstance.state.user.id) : null;  // NOSONAR
      }}
    >
      <div className="">
        <div className="agencies-filters" >
          <Input
            placeholder="Search by Name"
            suffix={
              searchTerm ? ( 
                <Icon
                  type="close"
                  onClick={() => setSearchTerm("")}
                  className="icon-style"
                  style={{ right: '0px' }}
                />
              ) : (
                <Icon
                  type="search"
                  className="icon-style"
                  style={{ right: '0px' }}
                />
              )
            }
            // onSearch={(value) => setSearchTerm(value)}
            onChange={handleSearchChange}
            // style={{ width: 300 }}
            className="searchinput agency-multiselect  "
            value={searchTerm}
          />
          <span ref={carrierWrapperRef} 
            className="drop-down-select-ui"
            // style={{ position: "relative", marginRight: "10px" }}
          >
            {/* <img src={DownArrowIcon} alt="arrow-down" style={{
              position: "absolute",
              zIndex: 1,
              right: 7,
              top: 10,
              width: "17px",
              // color:"rgba(0, 0, 0, 0.45)",
              color: "#cfc9c9"

            }} /> */}
            <Select
              open={carrierDropdownOpen}
              onDropdownVisibleChange={(open) => setCarrierDropdownOpen(open)}
              placeholder="Select Carrier "
              // onChange={(value) => console.log(value)}
              onChange={handleCarrierChange}
              // allowClear={true}
              mode="multiple"
              maxTagCount={1}
              value={carrierFilter}
              style={{
                // width: 300,
                backgroundColor: "#fff",
                borderRadius: "20px",
                // border: "1px solid #cfc9c9",
              }}
              className="agency-multiselect-dropdown agency-multiselect"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {CarrierList.map((carrier) => (
                <Option key={carrier.id} value={carrier.name}>
                  {carrier.name}
                </Option>
              ))}
            </Select>
            <Icon
              type={carrierDropdownOpen ? "up" : "down"}
              className="icon-style right-15"
              onClick={() => setCarrierDropdownOpen((prev) => !prev)}
            />
          </span>
          <span ref={stateWrapperRef} 
          className="drop-down-select-ui"
          // style={{ position: "relative" }}
          >
            {/* <img src={DownArrowIcon} alt="arrow-down" style={{
              position: "absolute",
              zIndex: 1,
              right: 7,
              top: 10,
              width: "17px",
              // color:"rgba(0, 0, 0, 0.45)",
              color: "#cfc9c9"

            }} /> */}
            <Select
              open={stateDropdownOpen}
              onDropdownVisibleChange={(open) => setStateDropdownOpen(open)}
              placeholder="Select State "
              onChange={handleStateChange}
              // allowClear={true}
              mode="multiple"
              maxTagCount={1}
              value={stateFilter}
              // onChange={(value) => console.log(value)}
              style={{
                // width: 300,
                backgroundColor: "#fff",
                borderRadius: "20px",
                // border: "1px solid #cfc9c9",
              }}
              className="agency-multiselect-dropdown  agency-multiselect"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {stateList.map((state) => (
                <Option key={state} value={state}>
                  {state}
                </Option>
              ))}
            </Select>
            <Icon
              type={stateDropdownOpen ? "up" : "down"}
              className="icon-style right-15"
              onClick={() => setStateDropdownOpen((prev) => !prev)}
            />
          </span>
          <Button
            style={{
              marginTop: "0px",
              marginLeft: "10px"

            }}
            type='primary'
            className='refresh-con'
            onClick={refreshTableData}
          >
            <Icon type="reload" />
          </Button>
        </div>
        <div>
          <Spin
            spinning={
              parentInstance.state.loading ||
              parentInstance.state.agencies_modal_loading
            }
          >
            <CustomAgGridTable
              rowDatas={filteredData}
              columnDefss={coleDef}
              gridApiOptions={{
                rowSelection: "multiple",
                ...gridOptions,
                getRowId: (params) => params.data.id,
                onSelectionChanged: handleSelectionChanged,
                suppressRowClickSelection: true,
                onGridReady: onGridReady,
                suppressHorizontalScroll: false,
              }}
              styles={{ height: "380px", minHeight: "350px" }}
            />
          </Spin>
        </div>
        <style jsx>{`
          .ag-theme-alpine {
            position: relative;
          }
          .ag-header {
            position: sticky;
            top: 0;
            z-index: 10; /* Keep the header above the body */
            background-color: #f8f8f8; /* Optional: Make header background different */
          }
          .ag-body-viewport {
            overflow-y: auto; /* Make the table body scrollable */
            max-height: 300px; /* Set the height for the body, this is the scrollable area */
          }
        `}</style>
      </div>
    </CustomModal>
  );
};

export default AgencyModal;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/Modals/AgencyModal.js